module.exports = Object.freeze({
  APPROVED: 'Approved',
  REJECTED: 'Rejected'
});